import { getFirebaseToken } from 'api/authentication';
import { signInWithToken } from '@quintoandar/firebase-client';
import { ApiResponseFirebaseAuthService } from 'models/ApiResponseFirebaseAuthService';

export class AuthenticationService {
  private static firebaseToken: string;
  private static firebaseAuthenticated: boolean = false;

  private static async getFirebaseToken(): Promise<string> {
    if (this.firebaseToken !== undefined) return this.firebaseToken;

    const tokenAPIResponse: ApiResponseFirebaseAuthService = await getFirebaseToken();
    return tokenAPIResponse?.firebase_json_web_token;
  }

  private static async signInToFirebase(token: string): Promise<firebase.auth.UserCredential> {
    return signInWithToken(token);
  }

  static async authenticateToFirebaseIfNeeded(): Promise<void> {
    if (this.firebaseAuthenticated) return;

    const firebaseToken = await this.getFirebaseToken();
    if (!firebaseToken) return;

    await this.signInToFirebase(firebaseToken);

    this.firebaseAuthenticated = true;
  }
}
